var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#3FA96A",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1476_172",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1476_172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 21.8166V20.4499C18.3333 20.161 19.1389 19.6055 19.75 18.7832C20.3611 17.961 20.6667 17.0277 20.6667 15.9832C20.6667 14.9388 20.3611 14.0055 19.75 13.1832C19.1389 12.361 18.3333 11.8055 17.3333 11.5166V10.1499C18.7111 10.461 19.8333 11.1581 20.7 12.2412C21.5667 13.3248 22 14.5721 22 15.9832C22 17.3943 21.5667 18.6415 20.7 19.7246C19.8333 20.8081 18.7111 21.5055 17.3333 21.8166ZM10 17.9999V13.9999H12.6667L16 10.6666V21.3332L12.6667 17.9999H10ZM17.3333 18.6666V13.2999C17.8556 13.5443 18.264 13.911 18.5587 14.3999C18.8529 14.8888 19 15.4221 19 15.9999C19 16.5666 18.8529 17.0915 18.5587 17.5746C18.264 18.0581 17.8556 18.4221 17.3333 18.6666Z",
    fill: "#3FA96A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.2eaf760ad5e0a44d490123cbfc1e15ce.svg";
export { ForwardRef as ReactComponent };